import { Component, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { catchError, EMPTY, switchMap } from 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConsentService } from '@markant-platform/consent/data-access';
import { SnackbarService } from '@markant-platform/shared/snackbar/feature';
import { handleDownloadByObjectUrl } from '@markant-platform/shared/util-helpers';
import { HttpErrorResponse } from '@angular/common/http';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'markant-platform-legal-document-download',
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, TranslocoModule],
  templateUrl: './legal-document-download.component.html',
  styleUrls: ['./legal-document-download.component.scss'],
})
export class LegalDocumentDownloadComponent {
  isLoading: boolean;
  downloadUrl!: string;
  showManualDownload = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly consentService: ConsentService,
    private readonly snackbarService: SnackbarService,
    private readonly destroyRef: DestroyRef
  ) {
    this.isLoading = true;

    this.route.queryParams
      .pipe(
        switchMap((queryParams: Params) => {
          if (!queryParams['organizationId'] || !queryParams['serviceId']) {
            throw new Error('Required parameters are missing');
          }
          return this.consentService.downloadServiceDocumentAsObjectUrl(
            queryParams['serviceId'],
            queryParams['organizationId']
          );
        }),
        catchError(err => {
          this.router.navigateByUrl('/').then(() => {
            if (err instanceof HttpErrorResponse) {
              this.snackbarService.showErrorSnackbarWithTransloco('consent.downloadLegalDocument.error.download');
              return;
            }

            this.snackbarService.showErrorSnackbarWithTransloco('consent.downloadLegalDocument.error.parameters');
          });

          return EMPTY;
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(url => {
        this.downloadUrl = url;
        const pdfWindow = window.open(url);
        if (!pdfWindow || pdfWindow.closed || typeof pdfWindow.closed === 'undefined') {
          this.showManualDownload = true;
        }
        this.isLoading = false;
      });
  }

  toDashboard(): void {
    this.router.navigateByUrl('/');
  }

  downloadContentManual(): void {
    handleDownloadByObjectUrl(this.downloadUrl);
  }
}
